import * as React from "react";
import { TooltipTrigger } from "react-ui";

import { Tooltip } from "../../Internals/Tooltip/Tooltip";

import { ErrorContainer } from "./Highlight.styles";

export interface HighlightProps {
    children: React.ReactNode;
    error?: string;
    tooltip?: string;
    tooltipWidth?: string | number;
    trigger?: TooltipTrigger;
}

export function Highlight(props: HighlightProps): JSX.Element {
    if (props.error) {
        const tooltipTrigger: TooltipTrigger = props.trigger || "hover";
        const tooltipContent = props.tooltip != undefined ? <div>{props.tooltip}</div> : props.error;

        return (
            <Tooltip pos="top center" trigger={tooltipTrigger} value={tooltipContent} width={props.tooltipWidth}>
                <ErrorContainer cursorPointer={tooltipTrigger === "click"}>{props.children}</ErrorContainer>
            </Tooltip>
        );
    }

    return <span>{props.children}</span>;
}
